import {
  AlertDialog,
  Checkbox,
  Icon,
  NewTable,
  Text,
  useToast,
} from '@vallourec-ui/vallourec-ui'
import React, { useCallback, useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'

import { isAxiosError } from 'axios'

import moment from 'moment'

import { generateReport as generateReportPost, updateRelease } from '@/api/post'

import { useSearchReport } from '@/stores/SearchReportStore'

import {
  ButtonContainer,
  Row,
  StyledButton,
  StyledTextButton,
  ContentContainer,
} from './style'
import { DataResultTemplate, ReportTest } from '@/@types/global'
import { getTemplate } from '@/api/get'
import { updateReportDocument } from '@/api/put'
import { ButtonsContainer } from '@/components/ImageCard/style'
import { TableWrapper } from '@/pages/Flow/_component/DataToResult/style'
import { useApp } from '@/stores/AppStore'
import { TESTS } from '@/utils/constants'
import {
  generateDocumentDefinitionSearch,
  getFilePDF,
} from '@/utils/pdfGenerator/pdfGenerator'
import {
  dealWithFile,
  downloadBase64,
  getDateNow,
  getFilesByPaths,
} from '@/utils/utils'

const DataToResult: React.FC = () => {
  const { t } = useTranslation()
  const { toast } = useToast()
  const {
    setIsLoading,
    templateColumn,
    templateRow,
    setTemplateRow,
    resultItems,
    setExecuteSearch,
    user,
  } = useApp()
  const {
    orderItem,
    type,
    clientHeader,
    descriptionHeader,
    projectHeader,
    setProjectHeader,
    inspectionHeader,
    setPedidoItemHeader,
    pedidoItemHeader,
    setCurrentItem,
    setResultItemsSelected,
    resultItemsSelected,
    currentItem,
    remark1,
    remark2,
    remark3,
    completeHeaderItem,
  } = useSearchReport()

  const [initialized, setInitialized] = useState(false)
  const [checkedAll, setCheckedAll] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false)
  const [descriptionDocuments, setDescriptionDocuments] = useState('')
  const [setItemsPerPage] = useState<number>(50)
  const [testSelectedResult, setTestSelectedResult] = useState<
    ReportTest | undefined
  >(undefined)

  useEffect(() => {
    if (templateRow.length > 0 && (!initialized || !templateRow[0].cell)) {
      addCellRow(templateRow)
      setTemplateRow([...templateRow])
      setInitialized(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialized, templateRow, setTemplateRow])

  const validatePermissionReport = (
    optionGenerate: string,
    typeCode: string
  ) => {
    let hasPermission = false
    if (user && user.permissions) {
      switch (optionGenerate) {
        case 'generateReport':
          hasPermission =
            user.permissions[typeCode.toLowerCase()].includes('elaborate') ||
            user.permissions[typeCode.toLowerCase()].includes('view')
          break
        case 'sendApprovalReport':
          hasPermission =
            user.permissions[typeCode.toLowerCase()].includes('elaborate')
          break
        default:
          break
      }
    }
    return hasPermission
  }

  const validateItemsSelectedReportNaceD = () => {
    if (
      testSelectedResult?.typeCode === 'corrosion' &&
      testSelectedResult.id === 'nace_d' &&
      resultItemsSelected
    ) {
      let id_ensaio = ''
      for (const item of resultItemsSelected) {
        if (item.id_ensaio) {
          if (id_ensaio == '') {
            id_ensaio = item.id_ensaio
          } else if (item.id_ensaio !== id_ensaio) {
            return true
          }
        }
      }
    }
    return false
  }

  const validateOneTestReport = () => {
    const allowOnlyOneTests = [
      'ctdo',
      'reeling',
      'collapse',
      'micro_cleanliness_d',
    ]
    const allowOnlyOneTestsLot = ['mpi']

    if (
      testSelectedResult &&
      resultItemsSelected &&
      resultItemsSelected.length > 1 &&
      (allowOnlyOneTests.includes(testSelectedResult.id) ||
        allowOnlyOneTestsLot.includes(testSelectedResult.id))
    ) {
      if (allowOnlyOneTestsLot.includes(testSelectedResult.id)) {
        const count: any[] = []
        for (const item of resultItemsSelected) {
          if (!count.includes(item.lot_id)) {
            count.push(item.lot_id)
          }
        }
        if (count.length > 1) {
          setResultItemsSelected([])
          return true
        }
      } else {
        setResultItemsSelected([])
        return true
      }
    }

    return false
  }

  const canGenerate = async (optionGenerate = '', justGenerate = false) => {
    let valid = true
    const permissionReport = testSelectedResult
      ? validatePermissionReport(optionGenerate, testSelectedResult.typeCode)
      : false
    if (!permissionReport) {
      toast({
        title: 'Error',
        description: t('user.permission_not_action'),
        type: 'error',
      })
      valid = false
    } else {
      if (!justGenerate && (!user || !user.hasSignature)) {
        toast({
          title: 'Error',
          description: t('user.signature_not_exists'),
          type: 'error',
        })
        valid = false
      }
      if (!resultItemsSelected || !resultItemsSelected.length) {
        toast({
          title: 'Error',
          description: t('generateReport.dataToResult.select_test'),
          type: 'error',
        })
        valid = false
      }
      if (validateOneTestReport()) {
        toast({
          title: 'Error',
          description: t('generateReport.dataToResult.one_test'),
          type: 'error',
        })
        valid = false
      }
      if (validateItemsSelectedReportNaceD()) {
        toast({
          title: 'Error',
          description: t('generateReport.dataToResult.multiples_test'),
          type: 'error',
        })
        valid = false
      }
    }

    return valid
  }

  const differentHeader = () => {
    return false
  }

  const generateNewSearchReport = async () => {
    const elaborationPosition = user?.userPosition ?? ' '
    const elaborationName = user?.userName ?? ' '

    if (
      currentItem &&
      resultItemsSelected &&
      user &&
      user.userPosition &&
      testSelectedResult &&
      currentItem.path_file &&
      currentItem.path_document_definition
    ) {
      let success = false
      try {
        const resultTemplate = await getTemplate({ id: 'template' })
        const generalContent = resultTemplate?.generalContent

        const reportFile = await getFilesByPaths({
          pathDD: currentItem.path_document_definition,
        })

        const { dd: documentDifinition } = reportFile

        if (documentDifinition) {
          const newDDSearch = generateDocumentDefinitionSearch({
            dd: JSON.parse(JSON.stringify(documentDifinition)),
            version: currentItem.version,
            dateNow: getDateNow(),
            test: currentItem,
            remark1,
            remark2,
            remark3,
            generalContent,
            elaboration: elaborationName,
            elaborationPosition,
            customFields: {
              completeHeaderItem,
              customer: clientHeader,
              description: descriptionHeader,
              inspection: inspectionHeader,
              project: projectHeader,
              orderItem: pedidoItemHeader,
              justGenerate: false,
              generateExcel: false,
            },
          })

          const newFileName = `${testSelectedResult.id}_${newDDSearch.newVersionName}.pdf`

          const file = await getFilePDF(
            newDDSearch.documentDefinition,
            newFileName
          )

          const dataFile = await dealWithFile(
            file,
            `report/${testSelectedResult.id}/${currentItem.id}/${file.name}`,
            currentItem.id,
            'path_file'
          )

          await updateReportDocument(dataFile)

          const dataFileDocumentDefinition = await dealWithFile(
            dataFile,
            `document_definition/${testSelectedResult.id}/${currentItem.id}/${file.name}`,
            currentItem.id,
            'path_document_definition'
          )

          await updateReportDocument(dataFileDocumentDefinition)

          await updateRelease({
            id: currentItem.id,
            dateNow: getDateNow(),
            currentDate: moment().format('MM/DD/YYYY HH:mm:ss'),
            email: user.email,
            user: user.userName,
            testId: testSelectedResult.id,
            selected: currentItem,
            site: currentItem.site,
            test: { name: testSelectedResult.name },
            remark1,
            remark2,
            remark3,
            customer: clientHeader,
            description: descriptionHeader,
            inspection: inspectionHeader,
            orderItem,
            elaboration: elaborationName,
            elaboration_position: elaborationPosition,
            reportApproval: '',
            reportApprovalPosition: '',
            path_file: dataFile.url,
            path_document_definition: dataFileDocumentDefinition.url,
            newVersionName: newDDSearch.newVersionName,
            newFileName,
          })
        }

        success = true
        toast({
          title: 'Success',
          description: t('application.commons.success.operation'),
          type: 'success',
        })
      } catch (error) {
        console.log(error)
        if (isAxiosError(error)) {
          toast({
            title: 'Error',
            description: error.response?.data?.errorMessage ?? error.message,
            type: 'error',
          })
        } else {
          toast({
            title: 'Error',
            description: `${error}`,
            type: 'error',
          })
        }
      } finally {
        if (success) {
          setExecuteSearch(true)
        }
      }
    }
  }

  const generateReport = async () => {
    const elaborationPosition = user?.userPosition ?? ' '
    const elaborationName = user?.userName ?? ' '

    if (currentItem && resultItemsSelected && user && user.userPosition) {
      let success = false
      try {
        let testIdValue = null
        if (testSelectedResult) {
          testIdValue = testSelectedResult.id
        }

        const result = await generateReportPost({
          updateRelease: currentItem.id,
          dateNow: getDateNow(),
          currentDate: moment().format('MM/DD/YYYY HH:mm:ss'),
          email: user.email,
          user: user.userName,
          testId: testIdValue,
          selected: currentItem,
          site: currentItem.site,
          test: { name: currentItem.test },
          remark1,
          remark2,
          remark3,
          customer: clientHeader,
          description: descriptionHeader,
          inspection: inspectionHeader,
          orderItem,
          // pqLot: undefined,
          // orderProcess: undefined,
          elaboration: elaborationName,
          elaboration_position: elaborationPosition,
          reportApproval: '',
          reportApprovalPosition: '',
        })

        downloadBase64(
          document,
          result.completeFileName ?? result.fileName,
          result.report,
          atob(result.report)
        )

        success = true
        toast({
          title: 'Success',
          description: t('application.commons.success.operation'),
          type: 'success',
        })
      } catch (error) {
        console.log(error)
        if (isAxiosError(error)) {
          toast({
            title: 'Error',
            description: error.response?.data?.errorMessage ?? error.message,
            type: 'error',
          })
        } else {
          toast({
            title: 'Error',
            description: `${error}`,
            type: 'error',
          })
        }
      } finally {
        if (success) {
          setExecuteSearch(true)
        }
      }
    }
  }

  const generate = async (
    justGenerate = false,
    optionGenerate = 'generateReport'
  ) => {
    let search = true
    try {
      setIsLoading(true)
      if (user && user.userPosition) {
        const isCanGenerate = await canGenerate(optionGenerate, justGenerate)
        if (isCanGenerate && resultItemsSelected) {
          const documents = []
          const versions: string[] = []

          for (const itemDoc of resultItemsSelected) {
            if (itemDoc.id_document) {
              documents.push(itemDoc.id_document)
              if (!versions.includes(itemDoc.document_version))
                versions.push(itemDoc.document_version)
            }
          }

          if (documents && documents.length) {
            setShowConfirm(true)
            setDescriptionDocuments(
              versions?.map((item) => `- ${item}.`).join('\n')
            )
          } else if (type === 'corrosion' && differentHeader()) {
            // showConfirmCorrosionHeader = 'open';
            toast({
              title: 'Error',
              description:
                /* t('user.not_position') */ 'Cabeçalho diferente. Falta implementar essa ação.', // TODO
              type: 'error',
            })
          } else if (
            (testSelectedResult?.id === 'microstructure_photos' || testSelectedResult?.id === 'microstructure_photos_longitudinal') &&
            currentItem?.path_file &&
            currentItem?.path_document_definition
          ) {
            await generateNewSearchReport()
          } else {
            await generateReport(justGenerate, false)
          }
        }
      } else {
        toast({
          title: 'Error',
          description: t('user.not_position'),
          type: 'error',
        })
      }
    } catch (error) {
      search = false
    } finally {
      setIsLoading(false)
    }
  }

  const getColumns = (columns: any) => {
    return [
      {
        id: 'cell',
        accessorKey: 'cell',
        header: '',
        cell: ({ cell }) => cell.getValue(),
      },
      ...columns,
    ]
  }

  const fillHeader = (index: number) => {
    const item = resultItems[index]
    setProjectHeader(`${item.project ? item.project : ''}`)
    setPedidoItemHeader(`${item.order_item ?? ''}`)

    const newTemplateRow = templateRow.map((element, idx) => {
      element.checkedHeader = idx === index ? !element.checkedHeader : false
      return element
    })
    addCellRow(newTemplateRow)
    setTemplateRow(newTemplateRow)
    setCurrentItem(item)
    setTestSelectedResult(TESTS.find((elem) => elem.id === item.test))
    fillResultChecked(resultItems, newTemplateRow)
  }

  const fillResultChecked = (
    resultItems: any[],
    templateRow: DataResultTemplate[]
  ) => {
    const itemsSelected = templateRow
      .filter((item) => item.checked)
      ?.map((item) => item.index)
    setResultItemsSelected(
      resultItems.filter((item, index) => {
        item.indexResultItems = index
        return itemsSelected.includes(index)
      })
    )
  }

  const addCellRow = (newTemplateRow: any) => {
    newTemplateRow.forEach((element: any, index: number) => {
      element.cell = (
        <Checkbox
          id={`checked-${index}`}
          name={`checked-${index}`}
          checked={element.checkedHeader}
          label=""
          onCheckedChange={() => fillHeader(index)}
        />
      )
    })
  }

  const renderTable = useCallback(() => {
    return templateColumn.length > 0 && templateRow.length > 0 ? (
      <TableWrapper>
        <NewTable.Root
          key="Table-with-result"
          columnIdWithRowspan="button"
          columns={getColumns(templateColumn)}
          data={templateRow}
          isBordered
          hasScroll
          simplePagination={
            <NewTable.Pagination
              key="NewTable-Pagination-results"
              previousPage={() => 0}
              nextPage={() => 0}
              getPageCount={() => 1}
              getCanPreviousPage={() => false}
              getCanNextPage={() => false}
              getState={() => {
                return {
                  pagination: {
                    pageIndex: 0,
                    pageSize: 1,
                  },
                }
              }}
              setPageSize={setItemsPerPage}
            />
          }
        />
        <Row
          style={{
            justifyContent: 'flex-end',
            marginTop: '15px',
            marginBottom: '15px',
          }}
        >
          <ButtonContainer>
            <StyledButton onClick={() => generate(true)}>
              <StyledTextButton>
                <Icon name="CheckLine" color="white" />
                {t<string>('', 'Exibir')}
              </StyledTextButton>
            </StyledButton>
          </ButtonContainer>
        </Row>
      </TableWrapper>
    ) : (
      <NewTable.Root key="Table-with-result-no-data" data={[]} columns={[]} />
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [templateColumn, templateRow, t])

  const confirm = async () => {
    try {
      setIsLoading(true)
      setShowConfirm(false)
      await generateReport()
    } catch (error) {
      console.log(error)
      if (isAxiosError(error)) {
        toast({ title: 'Error', description: error.message, type: 'error' })
      }
    } finally {
      setIsLoading(false)
    }
  }

  const onOutsideClickAlert = () => {
    setShowConfirm(false)
  }

  return (
    <>
      <ContentContainer>{renderTable()}</ContentContainer>
      <AlertDialog
        open={showConfirm}
        variant="warn"
        title={`${t<string>('generateReport.dataToResult.hasDocuments')}`}
        description={descriptionDocuments}
        onOpenChange={onOutsideClickAlert}
        close={onOutsideClickAlert}
        footer={
          <ButtonsContainer>
            <StyledButton
              onClick={onOutsideClickAlert}
              key="cancel-button"
              variant="warnWithBorders"
            >
              <Text>{t<string>('application.button.cancel')}</Text>
            </StyledButton>
            <StyledButton
              onClick={confirm}
              key="confirm-button"
              variant="warnWithoutBorders"
            >
              <Text>{t<string>('application.button.confirm')}</Text>
            </StyledButton>
          </ButtonsContainer>
        }
      />
    </>
  )
}

export default DataToResult
